import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr, propShape } from '../../../../helpers/custom-prop-types';
import HtmlLink from '../../../Ui/Common/HtmlLink';
const SeminarOneTitle = (props) => {
    const { className, seminar } = props;
    const { information: { title }, organization, } = seminar;
    return (_jsx("div", Object.assign({ className: clsx('client_seminar_one_title', className) }, { children: _jsxs("div", Object.assign({ className: 'title_inner' }, { children: [organization && (_jsx("div", Object.assign({ className: 'title_unit' }, { children: _jsx(HtmlLink, Object.assign({ className: 'unit_text', isNoLinkComponent: organization.urlCode ? undefined : 'div', target: '_blank', to: `/solutions/${organization.urlCode}` }, { children: organization.name })) }))), _jsx("div", Object.assign({ className: 'title_text' }, { children: title }))] })) })));
};
SeminarOneTitle.propTypes = {
    className: propStr(),
    seminar: propShape().isRequired,
};
SeminarOneTitle.defaultProps = {
    className: '',
};
export default SeminarOneTitle;
